import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ListFiscalYearsResponse } from '@/api/handlers/resources/periods/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PeriodQueryKeys } from './periodQueryKeys';

/**
 * Every fiscal year, newest first — the Periods screen's year selector. Never
 * rejects (envelope contract); read `data.success` at the call site.
 */
export const useFiscalYearsQuery = () => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<ListFiscalYearsResponse>>({
        queryKey: PeriodQueryKeys.fiscalYears(),
        queryFn: () => apiClient.periods.listFiscalYears(),
    });
};
